// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ks76V","actions":"style_actions__NaAk0","actions_btn":"style_actions_btn__1Oxqm"};